<div class="container-loader">
  <ngx-loading [show]="true" [config]="loaderConfig"></ngx-loading>
</div>